export default async function ({ $auth, redirect }) {
  await $auth.logout()

  // to remove explicitely the redirect key from local storage
  $auth.$storage.removeUniversal('redirect')

  return redirect('/login')
}
